import http from '@/components/services/http-common';
import formatter from '@/components/services/formatter';

// employeeReviews/condition API
export const conditionGets = ( roots) => {
  console.log(roots)
  return http
    .get('routemenus/v2', {
      params: {
        parentId: roots.length==0? null: roots[roots.length-1]
      }
    })
    .then(res => {
      res.data.data= res.data.data.map(x => {
        // x.transTitle = t(x.title)
        return x
      })
      return res.data
    })
}

export const Get = id => http.get(`routemenus/${id}`).then(res => res.data);

export const Post = (payload) => http.post('routeMenus', payload);

export const Put = (id, payload) => http.put(`routemenus/${id}`, payload);

export const changeOrder = (id, type, reload) => http.put(`routemenus/${id}/order`, {},{
  params: {
    type: type
  }
}).then(() => reload());

export const conditionDelete = id => http.delete(`employeeReviews/condition/${id}`);
